'use client';

import { AboutSection } from './components';
import { CompanyFacts } from './components';
import { ConnectWithUs } from './components';

export function ClientAboutSection() {
  return <AboutSection />;
}

export function ClientCompanyFacts() {
  return <CompanyFacts />;
}

export function ClientConnectWithUs() {
  return <ConnectWithUs />;
}
